// translations.js - Multi-language support for Saluki Commission

export const translations = {
  // HEADER / HOME PAGE
  header: {
    title: {
      id: 'Saluki Commission',
      en: 'Saluki Commission'
    },
    subtitle: {
      id: 'Buka untuk komisi & kolaborasi ✨',
      en: 'Open for commission & collaboration ✨'
    },
    serviceType: {
      id: 'Fanart / Ilustrasi / Desain',
      en: 'Fanart / Illustration / Design'
    },
    buttons: {
      about: {
        id: 'TENTANG SAYA →',
        en: 'ABOUT ME →'
      },
      portofolio: {
        id: 'PORTOFOLIO →',
        en: 'PORTOFOLIO →'
      },
      pricelist: {
        id: 'DAFTAR HARGA →',
        en: 'PRICE LIST →'
      },
      terms: {
        id: 'SYARAT & KETENTUAN →',
        en: 'TERMS & CONDITIONS →'
      },
      back: {
        id: '← Kembali ke Beranda',
        en: '← Back to Home'
      }
    }
  },

  // ABOUT ME PAGE
  about: {
    title: {
      id: 'Tentang Saya',
      en: 'About Me'
    },
    description: {
      id: 'Kenali seniman di balik karya',
      en: 'Get to know the artist behind the work'
    },
    introCard: {
      title: {
        id: 'Kreator di balik Saluki Commission 👋',
        en: 'The creator behind Saluki Commission 👋'
      },
      text1: {
        id: 'Saya adalah seorang freelance kreatif yang terbuka untuk komisi dan kolaborasi.',
        en: 'I\'m a freelance creative open for commissions and collaborations.'
      },
      text2: {
        id: 'Saya fokus menghasilkan karya yang bersih, estetik, dan penuh perhatian sesuai kebutuhan setiap klien.',
        en: 'I focus on delivering clean, aesthetic, and thoughtful work based on each client\'s needs.'
      },
      text3: {
        id: 'Setiap proyek ditangani secara personal, dengan komunikasi yang jelas dan perhatian terhadap detail.',
        en: 'Every project is handled personally, with clear communication and attention to detail.'
      },
      text4: {
        id: 'Jangan ragu untuk menghubungi jika Anda ingin bekerja sama!',
        en: 'Feel free to reach out if you\'d like to work together!'
      }
    },
    whoIAm: {
      title: {
        id: 'Siapa Saya',
        en: 'Who I Am'
      },
      text1: {
        id: 'Saya adalah seorang seniman freelance yang bersemangat dengan spesialisasi dalam ilustrasi digital, desain karakter, dan penceritaan visual kreatif. Karya saya menggabungkan keterampilan teknis dengan visi artistik untuk menciptakan karya yang beresonansi dengan klien dan audiens.',
        en: 'I\'m a passionate freelance artist specializing in digital illustration, character design, and creative visual storytelling. My work combines technical skill with artistic vision to create pieces that resonate with clients and audiences alike.'
      },
      text2: {
        id: 'Dengan pengalaman bertahun-tahun di industri ini, saya telah mengembangkan gaya yang serbaguna yang dapat beradaptasi dengan berbagai kebutuhan artistik sambil mempertahankan kualitas estetika khas yang membedakan karya saya.',
        en: 'With years of experience in the industry, I\'ve developed a versatile style that can adapt to various artistic needs while maintaining a distinctive aesthetic quality that sets my work apart.'
      }
    },
    approach: {
      title: {
        id: 'Pendekatan Saya',
        en: 'My Approach'
      },
      text1: {
        id: 'Setiap proyek dimulai dengan memahami visi Anda. Saya percaya pada penciptaan kolaboratif, di mana umpan balik klien dan keahlian artistik bersatu untuk menghasilkan hasil yang luar biasa.',
        en: 'Every project begins with understanding your vision. I believe in collaborative creation, where client feedback and artistic expertise come together to produce exceptional results.'
      },
      text2: {
        id: 'Kualitas dan profesionalisme adalah inti dari pekerjaan saya. Dari konsep awal hingga pengiriman akhir, saya memastikan komunikasi yang jelas, pembaruan tepat waktu, dan perhatian yang cermat terhadap detail.',
        en: 'Quality and professionalism are at the core of my work. From initial concept to final delivery, I ensure clear communication, timely updates, and meticulous attention to detail.'
      }
    },
    skills: {
      title: {
        id: 'Keahlian & Keahlian',
        en: 'Skills & Expertise'
      },
      items: {
        id: ['Ilustrasi Digital', 'Desain Karakter', 'Seni Konsep', 'Fanart', 'Potret', 'Gaya Chibi', 'Seni Latar Belakang', 'Teori Warna'],
        en: ['Digital Illustration', 'Character Design', 'Concept Art', 'Fanart', 'Portrait', 'Chibi Style', 'Background Art', 'Color Theory']
      }
    },
    whyChoose: {
      title: {
        id: 'Mengapa Memilih Saya',
        en: 'Why Choose Me'
      },
      items: {
        id: [
          'Layanan profesional dan terpercaya dengan komunikasi yang jelas',
          'Proses kerja yang fleksibel yang beradaptasi dengan kebutuhan Anda',
          'Karya berkualitas tinggi yang dikirimkan tepat waktu',
          'Kebijakan revisi yang wajar untuk memastikan kepuasan Anda',
          'Bersemangat untuk mewujudkan visi kreatif Anda'
        ],
        en: [
          'Professional and reliable service with clear communication',
          'Flexible working process that adapts to your needs',
          'High-quality artwork delivered on time',
          'Reasonable revision policy to ensure your satisfaction',
          'Passionate about bringing your creative vision to life'
        ]
      }
    }
  },

  // PORTOFOLIO PAGE
  portofolio: {
    title: {
      id: 'Portofolio',
      en: 'Portofolio'
    },
    description: {
      id: 'Jelajahi karya dan proyek kreatif terbaru saya',
      en: 'Explore my recent works and creative projects'
    },
    viewDetails: {
      id: 'Lihat Detail',
      en: 'View Details'
    }
  },

  // PRICE LIST PAGE
  pricelist: {
    title: {
      id: 'Daftar Harga',
      en: 'Price List'
    },
    subtitle: {
      id: 'Harga transparan untuk karya berkualitas',
      en: 'Transparent pricing for quality artwork'
    },
    currency: {
      rate: {
        id: '1 USD ≈ IDR 16,700',
        en: '1 USD ≈ IDR 16,700'
      },
      note: {
        id: 'Anda dapat mengecek kurs terbaru di situs web konversi mata uang lainnya',
        en: 'You can check for updated currency rates on other currency converter websites'
      }
    },
    services: {
      headshot: {
        name: { id: 'Headshot', en: 'Headshot' },
        description: { id: 'Potret karakter dari bahu ke atas', en: 'Character portrait from shoulders up' },
        price: 'IDR 90k',
        priceUSD: '~$5.4',
        duration: { id: '3-5 hari', en: '3-5 days' }
      },
      bustUp: {
        name: { id: 'Bust Up', en: 'Bust Up' },
        description: { id: 'Karakter dari pinggang ke atas dengan detail', en: 'Character from waist up with details' },
        price: 'IDR 120k',
        priceUSD: '~$7.2',
        duration: { id: '5-7 hari', en: '5-7 days' }
      },
      halfBody: {
        name: { id: 'Half Body', en: 'Half Body' },
        description: { id: 'Ilustrasi karakter lengkap setengah badan', en: 'Complete half body character illustration' },
        price: 'IDR 150k',
        priceUSD: '~$9',
        duration: { id: '7-10 hari', en: '7-10 days' }
      },
      kneeUp: {
        name: { id: 'Knee Up', en: 'Knee Up' },
        description: { id: 'Karakter dari lutut ke atas', en: 'Character from knees up' },
        price: 'IDR 180k',
        priceUSD: '~$10.8',
        duration: { id: '7-10 hari', en: '7-10 days' }
      }
    },
    notes: {
      title: { id: '📋 Catatan Penting:', en: '📋 Important Notes:' },
      items: {
        id: [
          'Harga tidak termasuk latar belakang atau latar belakang polos (berwarna)',
          'Tidak tersedia untuk penggunaan komersial',
          'Pembayaran 50% di muka diperlukan untuk memulai komisi',
          'Sisa 50% jatuh tempo sebelum pengiriman akhir',
          'Pesanan cepat tersedia dengan biaya tambahan 50%',
          'Harga termasuk hingga 3 putaran revisi'
        ],
        en: [
          'Prices do not include background or plain background (colored)',
          'Not available for commercial use',
          '50% upfront payment required to start the commission',
          'Remaining 50% due before final delivery',
          'Rush orders available with 50% additional charge',
          'Prices include up to 3 rounds of revisions'
        ]
      }
    },
    wontDo: {
      title: { id: '🚫 Yang Tidak Saya Kerjakan:', en: '🚫 Won\'t Do:' },
      items: {
        id: ['Mecha/Armor', 'Desain Detail Berlebihan', 'Furry', 'Elderly', 'NSFW Ekstrem', 'Gore'],
        en: ['Mecha/Armor', 'Overly Detailed Design', 'Furry', 'Elderly', 'Extreme NSFW', 'Gore']
      }
    },
    payment: {
      title: { id: '💳 Metode Pembayaran:', en: '💳 Payment Methods:' },
      methods: {
        local: {
          title: { id: 'Lokal (Indonesia)', en: 'Local (Indonesia)' },
          items: ['QRIS', 'ShopeePay', 'GoPay', 'Bank Transfer']
        },
        international: {
          title: { id: 'Internasional', en: 'International' },
          items: ['PayPal', 'Cryptocurrency (USDT, BTC, ETH)']
        }
      },
      note: {
        id: 'Untuk pembayaran crypto, silakan hubungi terlebih dahulu untuk detail wallet',
        en: 'For crypto payments, please contact first for wallet details'
      }
    }
  },

  // TERMS PAGE
  terms: {
    title: {
      id: 'Syarat & Ketentuan',
      en: 'Terms & Conditions'
    },
    subtitle: {
      id: 'Harap baca dengan seksama sebelum melakukan komisi',
      en: 'Please read carefully before commissioning'
    },
    commissionOpen: {
      id: 'Komisi Terbuka',
      en: 'Commission Open'
    },
    process: {
      title: { id: '📝 Proses Komisi', en: '📝 Commission Process' },
      items: {
        id: [
          'Pembayaran di muka 50% dilakukan setelah sketsa awal disetujui',
          'Pemrosesan 3-10 hari sesuai kompleksitas dan antrian',
          'Berikan deskripsi yang jelas atau referensi karakter',
          'Revisi maksimal 3x, lebih dari itu akan dikenakan biaya tambahan',
          'Tidak ada pengembalian dana setelah sketsa disetujui',
          'Biaya tambahan 50% untuk pesanan cepat (rush order)',
          'Konfirmasi detail proyek sebelum pembayaran dilakukan'
        ],
        en: [
          '50% upfront payment is made after the initial sketch is approved',
          'Processing 3-10 days according to complexity and queue',
          'Provide clear description or character reference',
          'Max 3 revisions, more than that will incur additional fees',
          'No refund after sketch is approved',
          '50% additional fee for rush orders',
          'Confirm project details before payment is made'
        ]
      }
    },
    payment: {
      title: { id: '💰 Ketentuan Pembayaran', en: '💰 Payment Terms' },
      items: {
        id: [
          'Pembayaran lokal: QRIS, ShopeePay, GoPay, Bank Transfer',
          'Pembayaran internasional: PayPal, Cryptocurrency (USDT, BTC, ETH)',
          'Untuk crypto, hubungi terlebih dahulu untuk alamat wallet',
          'Harga dalam IDR (Rupiah Indonesia) atau USD untuk klien internasional',
          'Pesanan cepat tersedia dengan biaya tambahan 50%',
          'Pengembalian dana hanya tersedia sebelum pekerjaan dimulai',
          'Tidak ada pengembalian dana setelah tahap persetujuan sketsa',
          'Paket pembayaran tersedia untuk pesanan di atas IDR 500k (diskusi terlebih dahulu)'
        ],
        en: [
          'Local payments: QRIS, ShopeePay, GoPay, Bank Transfer',
          'International payments: PayPal, Cryptocurrency (USDT, BTC, ETH)',
          'For crypto, contact first for wallet address',
          'Prices in IDR (Indonesian Rupiah) or USD for international clients',
          'Rush orders available with additional 50% fee',
          'Refunds only available before work has started',
          'No refunds after sketch approval stage',
          'Payment plans available for orders over IDR 500k (discuss in advance)'
        ]
      }
    },
    revisions: {
      title: { id: '🎨 Revisi & Perubahan', en: '🎨 Revisions & Changes' },
      items: {
        id: [
          'Hingga 3 putaran revisi kecil termasuk dalam harga dasar',
          'Perubahan besar setelah persetujuan sketsa dapat dikenakan biaya tambahan',
          'Putaran revisi tambahan tersedia dengan harga IDR 25k per putaran',
          'Harap berikan umpan balik yang jelas untuk menghindari kesalahpahaman',
          'Revisi harus diminta dalam waktu 7 hari setelah menerima draft',
          'Perubahan konsep total setelah sketsa final tidak dapat dilakukan'
        ],
        en: [
          'Up to 3 rounds of minor revisions included in the base price',
          'Major changes after sketch approval may incur additional fees',
          'Additional revision rounds available for IDR 25k each',
          'Please provide clear feedback to avoid miscommunication',
          'Revisions must be requested within 7 days of receiving the draft',
          'Total concept changes after final sketch cannot be accommodated'
        ]
      }
    },
    timeline: {
      title: { id: '⏰ Timeline & Pengiriman', en: '⏰ Timeline & Delivery' },
      items: {
        id: [
          'Waktu pengiriman yang diperkirakan adalah perkiraan dan dapat bervariasi',
          'Proyek kompleks mungkin memerlukan waktu tambahan',
          'Saya akan terus memberi tahu Anda tentang kemajuan selama komisi',
          'Penundaan akan dikomunikasikan sedini mungkin',
          'Pengiriman cepat tersedia dengan pengaturan sebelumnya dan biaya tambahan',
          'File final dikirim dalam format PNG/JPG beresolusi tinggi',
          'File sumber (PSD/SAI) tersedia dengan biaya tambahan'
        ],
        en: [
          'Estimated delivery times are approximate and may vary',
          'Complex projects may require additional time',
          'I\'ll keep you updated on progress throughout the commission',
          'Delays will be communicated as early as possible',
          'Rush delivery available with prior arrangement and additional fee',
          'Final files delivered in high-resolution PNG/JPG format',
          'Source files (PSD/SAI) available for additional fee'
        ]
      }
    },
    rights: {
      title: { id: '©️ Hak & Penggunaan', en: '©️ Rights & Usage' },
      items: {
        id: [
          'Saya mempertahankan hak cipta untuk semua karya seni yang dikerjakan',
          'Penggunaan pribadi termasuk dalam harga komisi',
          'Penggunaan komersial memerlukan lisensi terpisah (biaya tambahan)',
          'Saya berhak memposting karya seni di portofolio saya',
          'Anda dapat memposting karya seni dengan kredit yang tepat kepada saya',
          'Karya seni tidak boleh digunakan untuk NFT, pelatihan AI, atau dijual kembali',
          'Watermark akan dihapus pada file final setelah pembayaran penuh'
        ],
        en: [
          'I retain the copyright to all commissioned artwork',
          'Personal use is included in the commission price',
          'Commercial use requires separate licensing (additional fee)',
          'I reserve the right to post the artwork in my portofolio',
          'You may post the artwork with proper credit to me',
          'Artwork may not be used for NFTs, AI training, or resale',
          'Watermark will be removed on final file after full payment'
        ]
      }
    },
    wontDraw: {
      title: { id: '🚫 Yang Tidak Akan Saya Gambar', en: '🚫 What I Will Not Draw' },
      items: {
        id: [
          'Konten yang penuh kebencian, diskriminatif, atau menyinggung',
          'Gore atau kekerasan ekstrem',
          'Konten NSFW yang melibatkan anak di bawah umur',
          'Desain mekanis yang kompleks (kendaraan, robot, dll.)',
          'Plagiarisme atau salinan langsung dari karya seniman lain',
          'Konten yang melanggar hak cipta atau hukum merek dagang',
          'Furry atau anthropomorphic art',
          'Desain dengan detail berlebihan (armor kompleks, dll.)'
        ],
        en: [
          'Hateful, discriminatory, or offensive content',
          'Extreme gore or violence',
          'NSFW content involving minors',
          'Complex mechanical designs (vehicles, robots, etc.)',
          'Plagiarism or direct copies of other artists\' work',
          'Content that violates copyright or trademark laws',
          'Furry or anthropomorphic art',
          'Overly detailed designs (complex armor, etc.)'
        ]
      }
    },
    warning: {
      title: { id: '⚠️ Pemberitahuan Penting', en: '⚠️ Important Notice' },
      text1: {
        id: 'Dengan melakukan komisi kepada saya, Anda setuju dengan syarat dan ketentuan ini. Ketentuan ini dapat berubah dan dapat diperbarui secara berkala. Harap periksa halaman ini sebelum setiap komisi untuk memastikan Anda mengetahui ketentuan saat ini.',
        en: 'By commissioning me, you agree to these terms and conditions. These terms are subject to change and may be updated periodically. Please check this page before each commission to ensure you\'re aware of the current terms.'
      },
      text2: {
        id: 'Jika Anda memiliki pertanyaan atau memerlukan klarifikasi tentang salah satu ketentuan ini, jangan ragu untuk menghubungi saya sebelum melakukan komisi Anda.',
        en: 'If you have any questions or need clarification on any of these terms, please don\'t hesitate to contact me before placing your commission.'
      }
    }
  },

  // LANGUAGE SWITCHER
  language: {
    switch: {
      id: 'English',
      en: 'Bahasa Indonesia'
    }
  }
};